import { Link } from "@inertiajs/react";
import { Home } from "lucide-react";
import {
	Breadcrumb,
	BreadcrumbItem,
	BreadcrumbLink,
	BreadcrumbList,
	BreadcrumbPage,
	BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

interface BreadcrumbItemType {
	name: string;
	path?: string;
}

interface BreadcrumbsProps {
	items: BreadcrumbItemType[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
	if (!items || items.length === 0) return null;

	return (
		<div className="mb-6">
			<Breadcrumb>
				<BreadcrumbList>
					<BreadcrumbItem>
						<BreadcrumbLink asChild>
							<Link href="/">
								<Home className="h-4 w-4" />
							</Link>
						</BreadcrumbLink>
					</BreadcrumbItem>
					{items.map((item, index) => (
						<div key={index} className="flex items-center gap-2">
							<BreadcrumbSeparator />
							<BreadcrumbItem>
								{index === items.length - 1 ? (
									<BreadcrumbPage>{item.name}</BreadcrumbPage>
								) : (
									<BreadcrumbLink asChild>
										<Link href={item.path || "#"}>{item.name}</Link>
									</BreadcrumbLink>
								)}
							</BreadcrumbItem>
						</div>
					))}
				</BreadcrumbList>
			</Breadcrumb>
		</div>
	);
}
